import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IBrand } from "../types/IBrand";

export type IBrandCustomizationMutationParameters = {
    brand: RelationalValue<IBrand>;
    data: Pick<IBrand, "primaryColor" | "secondaryColor"> & { logo?: File };
};

export type IBrandCustomizationMutationResult = IBrand;

export const brandCustomizationMutation: IApiMutationFunction<IBrandCustomizationMutationParameters> = ({
    brand,
    data,
}) => {
    const { primaryColor, secondaryColor, logo } = data;

    const formData = new FormData();

    formData.append("uuid", mapRelationalValue(brand) as string);
    formData.append("primaryColor", primaryColor ?? "");
    formData.append("secondaryColor", secondaryColor ?? "");

    if (logo) {
        formData.append("logo", logo);
    }

    return {
        method: "POST",
        url: `/brands/customization/${mapRelationalValue(brand)}`,
        headers: {
            "Content-Type": "multipart/form-data",
        },
        data: formData,
    };
};

export const useBrandCustomizationMutation = createApiMutationHook<
    IBrandCustomizationMutationParameters,
    IBrandCustomizationMutationResult
>(brandCustomizationMutation);
